import React from 'react'

const Footer = () => {
  return (
    <footer className="footer mt-auto py-3" style={{backgroundColor:'var(--color-bg)'}}>
        <div className="container">
            <span className="text-muted">Aplikacja zrobiona przez NaukaOdZera ©️ 2024</span>
        </div>
    </footer>
  )
}

export default Footer